import * as Ably from 'ably'

export default defineNuxtPlugin(() => {
  const { socketURL, isDev, apiURL } = useRuntimeConfig().public
  const { auth } = $store()

  let $io: Ably.Realtime | null = null
  const channels: { [key: string]: any } = {}
  const connect = (isClient: boolean = true) => {
    const workspaceId = auth.workspaceId
    const accessToken = auth.accessToken
    const options: any = isClient
      ? {
          authUrl: apiURL + '/system/auth-ably',
          authHeaders: {
            Authorization: 'Bearer ' + accessToken || '',
            'hts-workspace': workspaceId || ''
          }
        }
      : {
          authUrl: apiURL + '/admincp/system/auth-ably',
          authHeaders: {
            Authorization: 'Bearer ' + accessToken || ''
          }
        }
    $io = new Ably.Realtime(options)
    $io.connection.on('connected', () => {
      // eslint-disable-next-line no-console
      console.log('Connected')
    })
    $io.connection.on('failed', () => {
      // eslint-disable-next-line no-console
      console.log('failed')
    })
  }

  const listen = (channel: string, callback: any) => {
    if (!$io) {
      return
    }
    const channelList = $io.channels.get(channel)
    channelList.subscribe(channel, (message) => {
      if (typeof callback === 'function') {
        callback(message.data)
      }
    })
  }

  const disconnect = () => {
    $io?.close()
    $io?.connection.on('disconnected', () => {
      // eslint-disable-next-line no-console
      console.log('disconnected')
    })
  }

  return {
    provide: {
      io: {
        connect,
        listen,
        disconnect
      }
    }
  }
})
